<template>
    <div class="row text-start">
        <div class="col-lg-5  checkout-content" style="min-height:300px; padding-left:30px;padding-top:10px;" :style="{'background-image': 'url(' + Store.Checkout.BackgroundImage + ')'}">
            <div class="text-start text-muted fw-bold small"><i class="bi-cart-check" style="color:black;"></i> Your Order:</div>
            <h5 style="color:black;margin-left:15px;padding-bottom:7px">
                In-Person Mobile Notary
            </h5>

            <div class="text-start text-muted fw-bold small">Pricing:</div>
            <div style="font-size:12px;" class="">
                <table class="mt-2" style="font-size: 10px; font-weight: bold; width: 100%; margin-left: 15px;">
                    <tr>
                        <td>General Notary Work Base Travel Fee:</td>
                        <td class="fw-bold" style="color:limegreen">${{FieldNotaryConfig.travelCostBaseFee.toFixed(2)}}</td>
                    </tr>
                    <tr>
                        <td>General Notary Work Mileage Fee:</td>
                        <td class="fw-bold" style="color:limegreen">${{FieldNotaryConfig.travelCostPerMile.toFixed(2)}}/mile</td>
                    </tr>
                    <tr>
                        <td>General Notary Work Add. Fees:</td>
                        <td><a style="font-weight:bold;padding-left:0;text-decoration:underline" class="link-dark" href="/content/Notary" target="_blank">Fee Schedule</a></td>
                    </tr>

                    <tr>
                        <td style="padding-top:20px">Loan Closing Package Flat Fee (no mileage):</td>
                        <td class="fw-bold" style="padding-top: 20px;color:limegreen">${{FieldNotaryConfig.notaryLoanClosingCost.toFixed(2)}}</td>
                    </tr>
                </table>
            </div>

            <div class="text-start text-muted fw-bold small" style="margin-top:20px">Note:</div>
            <ul class="" v-bind:style="{'color': FieldNotaryConfig.allowResidentialSignings ? 'black' : 'red'}" style="font-style:italic; list-style: none; font-size: 12px; padding-left: 15px; margin-bottom:0; ">
                <li v-if="!FieldNotaryConfig.allowResidentialSignings"><i class="bi-exclamation-triangle"></i>&nbsp; At this time <span class="fw-bold">residential address meeting locations are not accepted.</span> If you enter a residential address, your meeting will be canceled. Thank you for understanding.</li>
                <li v-if="FieldNotaryConfig.allowResidentialSignings"><i class="bi-info-circle"></i>&nbsp; In-person signings are available at <span class="">residential and commerical address meeting locations.</span></li>
            </ul>

            <div class="">
                <img src="/images/locmapflavor.png" style="width:100%" />
            </div>
        </div>
        <div class="col-lg-7 p-0" style="border-left:1px solid lightgrey">

            <div class="position-relative text-center px-3" style="top:30px;">

                <div class="h5 fw-semibold text-capitalize">Tell Us Where To Meet You.</div>
                <!-- Input Card -->

                <div class="p-2 mb-1 shadow-sm" style="">
                    <div class="fw-bold p-0 mb-1" style="color:limegreen">&nbsp; Enter Notarization Meeting Address or Place*</div>

                    <input autofocus v-model="Store.Checkout.Cart.StartAddress" type="text" class="form-control form-control-sm" id="fnAddress" placeholder="<enter full address>" aria-label="full address">
                    <label class="small text-muted fw-bold" style="font-size:10px">&nbsp; (this is the location where you wish to meet your Notary)</label>
                    <div class="blink text-red fw-bold text-center mt-2" v-if="StartError">{{StartError}}</div>
                </div>
                <!-- End Input Card -->
                <div class="">&nbsp;</div>

                <div class="shadow-sm p-2 mb-1">
                    <div v-if="FieldNotaryConfig.offerLoanClosings" class="fw-bold p-0 mb-1" style="color:limegreen">&nbsp;What Type Of Signing Are You Requesting?</div>
                    <div v-if="!FieldNotaryConfig.offerLoanClosings" class="fw-bold p-0 mb-1" style="color:limegreen">&nbsp;This is a "General Notary Appointment"</div>
                    <table style="width:100%" class="mt-1 mb-3">
                        <tr>
                            <!-- GNW -->
                            <td :class="Store.Checkout.Cart.NotaryServiceType == 0? 'shadow':''">
                                <input v-model="Store.Checkout.Cart.NotaryServiceType" :value="0" type="radio" class="btn-check" name="btnradio" id='option1' autocomplete="off">
                                <label style="width:100%" class="btn btn-outline-primary" for="option1">
                                    General Notarization<br>   
                                    <span style="font-size:12px" class="fw-light">
                                        starting at ${{FieldNotaryConfig.travelCostBaseFee.toString().toSmartFixed(2)}} + ${{FieldNotaryConfig.travelCostPerMile.toString().toSmartFixed(2)}} / mi
                                    </span><br />
                                </label>
                            </td>

                            <!-- Loan Package -->
                            <td :class="Store.Checkout.Cart.NotaryServiceType == 1? 'shadow':''" v-if="FieldNotaryConfig.offerLoanClosings">
                                <input v-model="Store.Checkout.Cart.NotaryServiceType" :value="1" type="radio" class="btn-check" name="btnradio" id="option2" autocomplete="off">
                                <label style="width:100%" class="btn btn-outline-primary" for="option2">
                                    Mortgage Loan Package<br>
                                    <span style="font-size:12px" class="fw-light">
                                        ${{FieldNotaryConfig.notaryLoanClosingCost.toFixed(2)}} flat fee<br />
                                    </span>
                                </label>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <div data-bs-keyboard="false" data-bs-backdrop="static" style="z-index:300;" id="MessageModalLoc" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="Modal Message" aria-hidden="true">
        <div class="modal-dialog modal-lg" style="margin-bottom: 150px;" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="" style="">
                        <h4 class="modal-title h4" style="margin: 0 auto !important;" v-html="ModalTitle"></h4>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="row mb-2 text-start">
                        <div class="col text-muted" style="font-size:14px;">
                            <span v-if="Store.Checkout.Cart.SelectedService == 'FieldNotarization'">Please be advised that since it's not possible to determine the full extent of notarial services required without reviewing your document(s), at check-out you will only be charged for the travel fee associated with this notarization. For information on additional charges (if any), please see <a class="link" target="_blank" href="/content/Notary">the complete fee schedule</a>.</span>
                            <br /><br />
                            <span>In the event of additional charges (depending on the particular services you request during your meeting, as outlined in <a class="link" target="_blank" href="/content/Notary">the complete fee schedule</a>), you will be notified during your meeting with the notary and charged at the conclusion of that meeting.</span>
                        </div>

                        <div class="form-check text-center">
                            <label ref="TravelFeeAgreeText" class="form-check-label blink" for="flexCheckDefault" style="color:red">
                                <input v-model="AgreeToTravelFee" class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                                I Understand &amp; Agree
                            </label>
                        </div>
                    </div>
                    <hr style="margin-bottom:5px;margin-top:5px;" />
                    <div class="row mb-0 mt-4" style="padding-top:0;">
                        <div class="modal-header" style="padding-top:0;padding-left:10px;">
                            <div class="" style="">
                                <h4 class="modal-title h4" style="margin: 0 auto !important;">
                                    <span style='color:green'><i class='bi-question-circle'></i> Confirm Meeting Location</span>
                                </h4>
                            </div>
                        </div>
                        <div class="col-md-6 text-center mt-3">
                            <span class="text-muted fw-bold">Service Address:</span><br /><span class="fw-bold" style="color:limegreen;">{{Store.Checkout.Cart.StartAddress}}</span>
                        </div>
                        <div class="col-md-6 text-center mt-3">
                            <span class="text-muted fw-bold">
                                <span v-if="Store.Checkout.Cart.NotaryServiceType == 0">Travel Fee:</span>
                                <span v-if="Store.Checkout.Cart.NotaryServiceType == 1">Notary Fee:</span>
                            </span><br /><span class="fw-bold" style="color:limegreen;">${{Store.Checkout.MapCost.toFixed(2)}} <span v-if="Store.Checkout.Cart.NotaryServiceType == 0">({{MapDistance}} miles)</span></span>
                        </div>
                    </div>
                    <div class="row ">
                        <div class="col-md-12">
                            <div class="border-1 shadow-sm" style="border: 1px solid lightgray;">

                                <iframe style="border:0;width:100%;height:400px"
                                        loading="lazy"
                                        allowfullscreen
                                        referrerpolicy="no-referrer-when-downgrade"
                                        :src="PlaceMapSrc">
                                </iframe>

                            </div>
                        </div>
                    </div>
                    <div class="row mb-5">
                        <div class="col-6" style="padding-right:0;">
                            <div class="d-grid gap-0">
                                <button type="button" @click="OnMakeLocationChanges" class="btn btn-sm btn-dark shadow btn-block" style="border-radius:0;">Make Changes</button>
                            </div>
                        </div>
                        <div class="col-6" style="padding-left:0;">
                            <div class="d-grid gap-0">
                                <button type="button" @click="OnLocationOK" class="btn btn-sm btn-primary shadow btn-block btn-pointer" style="border-radius:0;">Looks Good</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import { useEditorStore } from '/src/stores/EditorStore';
    import EventHub from '/src/Util/EventHub.js';
    import axios from '/src/components/NovaAxios.js';
    import { computed, ref, nextTick } from 'vue'
    import { toast } from 'vue3-toastify';

    export default {
        name: 'VenueSelectFieldNotary',
        components: {
        },
        watch:{
            
        },
        props: {
        },
        data() {
            return {
                Store: {},
                StartError:'',
                ModalTitle: '',
                MapDistance: 0,
                ModalMessage: '',
                PlaceMapSrc: '',
                ModalObjLoc: null,
                AgreeToTravelFee: false,
            };
        },
        methods:
        {
            OnStepActivated: async function(){
                if(this.Store.Checkout.Cart.CurrentStep == 1 && this.Store.Checkout.Cart.SelectedService != "FieldNotarization"){
                    //init
                }
            },
            OnLocationOK: function () {                
                if (!this.AgreeToTravelFee) {                    
                    toast.error("You must agree to the Travel Fee notice (top) before continuing.");
                    this.$refs.TravelFeeAgreeText.classList.remove('blink');
                    nextTick().then(() => {
                        setTimeout(() => this.$refs.TravelFeeAgreeText.classList.add('blink'), 500);
                    });
                    return;
                }
                
                this.ModalObjLoc.hide();
                this.Store.Checkout.Cart.Price = +this.Store.Checkout.MapCost?.toFixed(2) || 0;
                this.Store.SetCurrentStep((this.Store.Checkout.Cart.CurrentStep || 0) + 1)
            },
            OnMakeLocationChanges: function () {
                this.ModalObjLoc.hide();               
            },
            OnCmdNext: async function () 
            {                    
                if (this.Store.Checkout.Cart.CurrentStep != 1 || this.Store.Checkout.Cart.SelectedService != "FieldNotarization"){               
                    debugger;
                    return;
                }

                this.StartError = '';  

                if (!this.Store.Checkout.Cart.StartAddress) {
                 nextTick().then(() => {
                     this.StartError = "Address can't be blank.";
                 });

                 toast.error("Address can't be blank.");
                 return;
             }

             await this.ValidateAndDisplayAddress(this.Store.Checkout.Cart.StartAddress);
             return;
            },
            ShowModal: function (title) {
                 this.ModalTitle = title;
                 this.ModalObjLoc.show();
            },
            ValidateAndDisplayAddress: async function (start) {
                this.StartError = "";
                EventHub.$emit("WizLoading", true);
        
                var token = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value;
                var that = this;
                // ajax to server to get distance and cost estimate
                axios.postForm('/API/GetMobileNotaryEstimate', { serviceAddress: start, serviceType: this.Store.Checkout.Cart.NotaryServiceType }, {
                    cache: false,
                    headers: {
                        'RequestVerificationToken': token
                    }
                }).then(function (response) {

                    EventHub.$emit("WizLoading", false);
                    if (response.data.success) {
                        that.Store.Checkout.MapCost = response.data.travelfee;                                               
                        that.Store.Checkout.Cart.MapDistance = +response.data.miles;
                        that.MapDistance = response.data.miles;
                        that.ModalMessage = "Confirm Your Service Request Address";
                        that.PlaceMapSrc = response.data.mapsrc;
                        that.ShowModal("<span style='color:green'><i class='bi-info-circle'></i> Travel Fee Notice</span>");
                        
                    }
                    else {
                        that.StartError = response.data.msg;
                        toast.error("There was an error. " + response.data.msg);
                    }
                }).catch(function (error) {
                    EventHub.$emit("WizLoading", false);
                    toast.error("There was an error. Please refresh the page and try again.");
                });
       
            },

        },
        computed:
        {
            FieldNotaryConfig: function () {
                if (this.Store && this.Store.TenantConfig && this.Store.TenantConfig.serviceConfigMobileNotary) {
                    return this.Store.TenantConfig.serviceConfigMobileNotary;
                }

                return {};
            }
        },
        beforeMount: function () {

        },
        created: function () {
            this.Store = useEditorStore();
        },
        activated() {
            this.Store.Checkout.NextButton.Text = "Confirm Address";
            this.Store.Checkout.NextButton.Icon = "bi-geo-alt";
            this.Store.Checkout.NextButton.IsVisible = true;


            this.ModalObjLoc = new bootstrap.Modal(document.getElementById('MessageModalLoc'));
            EventHub.$on('OnCmdNext', this.OnCmdNext);
            EventHub.$on('OnStepActivated', this.OnStepActivated);
        },
        beforeUnmount: function () {
            EventHub.$off('OnStepActivated', this.OnStepActivated);
            EventHub.$off('OnCmdNext', this.OnCmdNext);
        }
    }
</script>

<style>
  
</style>